import React, { Fragment, useState } from "react"
import { useSelector } from "react-redux"
import { FaPlus } from "react-icons/fa"
import { useTranslation } from "react-i18next"

import { Tooltip } from "components"
import { thousandSeparator } from "utils"
import TnmwTopupModal from "./TnmwTopupModal"
import classes from "./index.module.scss"
import clsx from "clsx"

const TnMyWallet = () => {
  const [t, i18n] = useTranslation()

  const wallet = useSelector(state => state.wallet)

  const [openTopupModal, setOpenTopupModal] = useState(false)

  const isLtr = i18n.dir(i18n.language) === "ltr"

  if (wallet === null) return null

  return (
    <Fragment>
      <div className={classes["row"]}>
        <div
          className={clsx(
            classes["wallet"],
            isLtr && classes["wallet-ltr"]
          )}
        >
          {t("اعتبار_سرویس")}:{" "}
          <b>{thousandSeparator(wallet.balance)}</b>
        </div>

        <Tooltip title={t("افزایش_اعتبار")}>
          <button
            onClick={() => setOpenTopupModal(true)}
            className={classes["button"]}
          >
            <FaPlus />
          </button>
        </Tooltip>
      </div>

      <TnmwTopupModal
        openTopupModal={openTopupModal}
        setOpenTopupModal={setOpenTopupModal}
      />
    </Fragment>
  )
}

export default TnMyWallet